import React, { useState } from "react";
import { Link } from "react-router-dom";
import Modal from "./modal";
import ContactUs from "./ContactUs";

const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <footer className="bg-gray-50 text-gray-800 pt-12 pb-6 px-6 border-t border-gray-300">
      {/* 🔚 Bottom Branding */}
      <div className="text-center text-sm text-gray-600 mt-12 pt-6 border-t border-gray-300">
        © 2025 <strong>7hillsLAB</strong>. All Rights Reserved.
      </div>
      
      {/* Modal with ContactUs form */}
      <Modal isOpen={modalOpen} onClose={() => setModalOpen(false)}>
        <ContactUs />
      </Modal>
    </footer>
  );
};

export default Footer;